import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import { useEffect } from "react";
import SeveralBrandsHeader from "@components/severalbrands/header";
import SeveralBrandsFooter from "@components/severalbrands/footer";
import { DomainInfo } from "@components/severalbrands/utils/services";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useDomainContext } from "@hooks/useDomainContext";

export default function SeveralBrandsWrapper({
    children,
    domainInfo,
    hideHeader = false,
    contentListExist = false,
}: {
    children: ReactNode;
    domainInfo: DomainInfo;
    hideHeader?: boolean;
    contentListExist?: boolean;
}): ReactElement {
    // Server pages expose visitDetails with a trafficSource; static / GraphQL
    // pages don't, so visitDetails is undefined and menus stay as-is.
    const { visitDetails } = useDomainContext();
    const hasTrafficSource = Boolean(
        visitDetails?.trafficSource &&
            visitDetails?.trafficSource !== "organic",
    );
    useEffect(() => {
        const targetId = window.location.hash.substring(1);
        if (targetId === "testimonials") {
            const targetElement = document.getElementById("testimonials-1");
            if (targetElement) {
                setTimeout(() => {
                    targetElement.scrollIntoView({
                        behavior: "smooth",
                    });
                }, 0);
            }
        }
    }, []);

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />

                <link
                    href="https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@100..900&display=swap"
                    rel="stylesheet"
                />
            </Head>
            <style jsx global>{`
                body {
                    overflow-x: unset;
                }
            `}</style>
            <GoogleReCaptchaProvider
                reCaptchaKey={
                    domainInfo?.recaptchaConfig?.key ??
                    (process.env
                        .NEXT_PUBLIC_SEVERAL_BRANDS_GOOGLE_RECAPTCHA_SITE_KEY as string)
                }
            >
                <div style={{ fontFamily: `'Lexend Deca', sans-serif` }}>
                    {!hideHeader && (
                        <SeveralBrandsHeader
                            domain={domainInfo}
                            hideMenu={hasTrafficSource}
                        />
                    )}

                    <main className="max-w-7xl 3xl:max-w-[120rem] mx-auto block px-4vw lg:px-4">
                        {children}
                    </main>

                    <SeveralBrandsFooter
                        domain={domainInfo}
                        contentListExist={contentListExist}
                        hideLinks={hasTrafficSource}
                    />
                </div>
            </GoogleReCaptchaProvider>
        </>
    );
}
